import { checkPermissionForAnyCustomer } from "@ROM/Permissions/utils";

export const canAccessCustomerAdmin = (user) => checkPermissionForAnyCustomer(user, "customer:admin:access");

export default { canAccessCustomerAdmin };
